import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlanMaintainComponent } from './plan-maintain/plan-maintain.component';
import { ConfigMaintainLayoutComponent } from './config-maintain-layout/config-maintain-layout.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ConfigMaintainRoutingModule } from './config-maintain-routing.module';
import { RsaProviderListComponent } from './rsa-provider-list.component';
import { GoogleMapsModule } from '@angular/google-maps';

@NgModule({
  declarations: [
    PlanMaintainComponent,
    ConfigMaintainLayoutComponent,
    RsaProviderListComponent
  ],
  imports: [
    CommonModule,
    ConfigMaintainRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    GoogleMapsModule
    // AgmCoreModule.forRoot({ apiKey: 'AIzaSyB0b6ZQqsbJqvBCXU7QKtLx_k_rriNqtVU' })
  ],
  providers: [provideHttpClient(withInterceptorsFromDi())]
})
export class ConfigMaintainModule { }
